module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hnUXp"))).then(() => parcelRequire('hEqeo'));